import dayjs, { Dayjs } from 'dayjs';

export type ScheduleDto = {
  id?: number;
  date?: string;
  relativeDate?: string;
  lastSent?: string;
};

export type ScheduleModel = {
  id?: number;
  date?: Dayjs;
  lastSent?: Dayjs;
  relativeDate?: string;
};

export function mapScheduleModelToDto(model: ScheduleModel): ScheduleDto {
  return {
    id: model.id,
    date: model.date ? model.date.format('YYYY-MM-DD HH:mm:ss') : undefined,
    lastSent: model.lastSent ? model.lastSent.format() : undefined,
    relativeDate: model.relativeDate,
  };
}

export function mapScheduleDtoToModel(dto: ScheduleDto): ScheduleModel {
  return {
    id: dto.id,
    date: dto.date ? dayjs(String(dto.date), 'YYYY-MM-DD HH:mm:ss') : undefined,
    lastSent: dto.lastSent ? dayjs(Date.parse(String(dto.lastSent))) : undefined,
    relativeDate: dto.relativeDate,
  };
}
